import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../types';
import {PageTitle} from "../../Components/Landmarks";
import {LibraryItemFormatView} from "./LibraryItemFormatView";
import {locations} from "../../Utilities/Location";
import {libraryCatalogApi} from "./libraryCatalogApi";
import {createListFromArrayOfObjects} from "../../Utilities/Types/listUtilities";
import type { ListItem } from "../../Utilities/Types/listUtilities";
import {resourceModel, formatModel} from "./libraryFactory";
import {SYSTEM_TYPES} from "./libraryConstants";

export const LibraryItemFormatContainer = ({
                                               handleApiCall,
                                               catalogFormatId,
                                               catalogItemId,
                                               redirect,
                                           }: ContextProps) => {

    const [item, setItem] = useState<Record<string, unknown> | null>();
    const [format, setFormat] = useState<Record<string, unknown> | null>();
    const [vendors, setVendors] = useState<ListItem[]>();
    const systemType = SYSTEM_TYPES.Textbooks;

    const handleReturn = () => {
        redirect(locations.LIBRARY_CATALOG.getLink(systemType).to)
    };

    const handleBarcode = (copyId: string) => {
        redirect(locations.DYMO_PRINT_LABEL.getLink(copyId).to)
    };

    const handleSaveResource = async (format: Record<string, unknown>) => {
        const shouldReturn = !(format as Record<string, unknown>)?.numberOfCopiesToAdd;
        const resetState = () => {
            setItem(null);
            setFormat(null);
        }
        return handleApiCall(() => libraryCatalogApi.saveFormat(format),
            shouldReturn ? handleReturn : resetState);
    };

    useEffect(() => {
        const getResource = () => {
            handleApiCall(() => libraryCatalogApi.getResource(catalogItemId), (results: Record<string, unknown>) => setItem(resourceModel(results)));
        }
        const getVendors = () => {
            handleApiCall(() => libraryCatalogApi.getVendors(systemType), (results: Record<string, unknown>[]) =>
                setVendors(createListFromArrayOfObjects(results, "vendorId", "name")));
        }
        const getFormat = () => {
            let result = (item as Record<string, unknown>)?.formats ? ((item as Record<string, unknown>).formats as Record<string, unknown>[])?.find((f: Record<string, unknown>) => f.catalogFormatId === catalogFormatId) : undefined;
            result = formatModel(result);
            setFormat(result);
        }
        if (catalogItemId && !item)
            getResource();
        if (catalogFormatId && item && !format)
            getFormat();
        if (!vendors)
            getVendors();
    }, [catalogItemId, catalogFormatId, item, systemType]);

    if (!format || !vendors) return <></>;

    return <>
        <PageTitle h1={`Item Format`}/>
        <LibraryItemFormatView
            handleBarcode={handleBarcode}
            handleReturn={handleReturn}
            handleSaveResource={handleSaveResource}
            format={format}
            title={item?.title as string}
            vendors={vendors}
        />
    </>;
};

